/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import ServiceRegistry from "bundle/util/ServiceRegistry";
import CommandReceiverServiceBase from "bundle/service/CommandReceiverService";
import IFrameMessageTypes from "common/constants/IFrameMessageTypes";
import SearchAPICommands from "common/constants/SearchAPICommands";
import SearchCommands from "app/commands/SearchCommands";
import Events from "bundle/constants/Events";
import { PreviewAPICommands, AppAPICommands } from "bundle/constants/APICommands";
import PreviewCommands from "app/commands/PreviewCommands";
import AppCommands from "bundle/commands/AppCommands";

export default class CommandReceiverService extends CommandReceiverServiceBase {
    constructor() {
        super();
        this._getCommands = {
            ...this._getCommands,
            ...this._getCommandsFor(PreviewAPICommands, PreviewCommands),
            ...this._getCommandsFor(AppAPICommands, AppCommands),
            ...this._getCommandsFor(SearchAPICommands, SearchCommands),
        };
    }

    initialize() {
        ServiceRegistry.getService("EventsService").registerEventListener(
            Events.APP_RENDERING_START,
            () => {
                if (ServiceRegistry.getService("AppStore").isInPreview) {
                    this.initializeHelper();
                }
            },
        );
    }

    initializeHelper() {
        this._messagingService = ServiceRegistry.getService("MessagingService");
        this._messagingService
            .listenForType(IFrameMessageTypes.EXECUTE_COMMAND, typeData => this.executeCommand(typeData));
    }

    executeCommand(data) {
        super.executeCommand(data)
            .then(result => {
                this._sendResult(data.commandId, true, result);
            })
            .catch(error => {
                this._sendResult(data.commandId, false, error);
            });
    }

    _sendResult(commandId, resolve, resultData) {
        const data = {
            commandId,
            resolve,
            resultData,
        };
        this._messagingService.sendMessage(IFrameMessageTypes.COMMAND_RESULT, data);
    }
}
